<div #dropzoneContainer class="dropzone">
    <!--begin::Message-->
    <div class="dz-message needsclick">
        <!--begin::Icon-->
        <i class="ki-outline ki-file-up text-primary fs-3x"></i>
        <!--end::Icon-->
        <!--begin::Info-->
        <div class="ms-4 me-4">
            <h3 class="fs-5 fw-bold text-gray-900 mb-1">{{title}}</h3>
            <span class="fs-7 d-flex align-items-start fw-semibold text-gray-500">{{description}}</span>
        </div>
        <!--end::Info-->
    </div>
</div>